<template>
  <div>
    <div class="set-up">
      <b-container>
        <b-row class="justify-content-center">
          <b-col cols="10" md="8">
            <h2 class="set-up__title sub-heading">
              How easy is it to get set up?
            </h2>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" lg="10">
            <div class="set-up__steps">
              <div v-for="(step, i) in steps" :key="i" class="step">
                <h3 :id="`step-${i + 1}`" class="step__title body-3">Step {{ i + 1 }}</h3>
                <p :aria-describedby="`step-${i + 1}`" class="step__description title-0" v-html="step" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Outcome",
    data: () => ({
      steps: [
        "Install the <a href='https://adobe.com/go/xd_to_flutter' target='_blank' rel='noreferrer''>AdobeXD plug-in</a>",
        "Install <a href='https://code.visualstudio.com/' target='_blank' rel='noreferrer'>VS Code</a> & <a href='https://flutter.dev/docs/get-started/editor?tab=vscode' target='_blank' rel='noreferrer'>the Flutter/Dart Extensions</a>",
        "Enable Hot Reload to see changes on a device or simulator",
        "Export artboards & components as reusable Flutter Widgets\n<span class='body-3'>and/or</span>\nCopy design elements to your clipboard &amp; paste the code into your editor",
      ],
    }),
  };
</script>

<style lang="scss">
  @import "../variables";

  .outcome {
    &__description {
      color: $body-1;
      margin-bottom: pxToRem(96);
    }
  }
  .set-up {
    &__title {
      text-align: center;
    }
    &__steps {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: pxToRem(24);
      position: relative;

      .step {
        padding: pxToRem(32);
        margin: pxToRem(30) pxToRem(16);
        background: $card;
        border-radius: 10px 10px 0px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
        width: 100%;
        height: fit-content;
        position: relative;

        @media (min-width: 576px) {
          width: 78%;
        }
        @media (min-width: 768px) {
          margin: pxToRem(24);
          width: 40%;
        }

        &__title {
          font-weight: 600;
          color: $body-2;
        }
        &__description {
          white-space: break-spaces;
          font-size: 26.25px;
          line-height: 42.5px;
          margin: 0;
          @media (min-width: 768px) {
            font-size: 20px;
            line-height: 24px;
          }
          a {
            color: white;
            text-decoration: underline;
          }

          span {
            @extend .step__title;
          }
        }

        &:nth-child(1) {
          @media (min-width: 576px) {
            right: pxToRem(65);
          }
          @media (min-width: 768px) {
            border-radius: 10px 10px 0px;
            right: unset;
          }

          // Connector
          &::after {
            @extend .connector;
            background: url("../assets/images/lines/line-mobile-1to2.png");
            width: 72px;
            height: 75px;
            bottom: -68px;
            right: 45%;

            @media (min-width: 576px) {
              bottom: -67px;
              right: 20%;
            }

            @media (min-width: 768px) {
              background: url("../assets/images/lines/line-desktop-1to2.png");
              width: 60px;
              height: 40px;
              right: -53px;
              bottom: 48px;
            }
          }
        }

        &:nth-child(2) {
          @media (min-width: 576px) {
            left: pxToRem(65);
          }
          @media (min-width: 768px) {
            border-radius: 10px 10px 10px 0px;
            left: unset;
          }
        }

        &:nth-child(3) {
          @media (min-width: 576px) {
            right: pxToRem(65);
          }
          @media (min-width: 768px) {
            border-radius: 10px 0px 10px 10px;
            right: unset;
          }

          // Connectors
          &::before {
            @extend .connector;
            background: url("../assets/images/lines/line-mobile-2to3.png");
            height: 72px;
            width: 76px;
            top: -65px;
            right: 45%;
            @media (min-width: 576px) {
              right: -4%;
              top: -66px;
            }
            @media (min-width: 768px) {
              background: url("../assets/images/lines/line-desktop-2to3.png");
              height: 60px;
              width: 128px;
              right: -25%;
              top: -54px;
            }
          }

          &::after {
            @extend .connector;
            background: url("../assets/images/lines/line-mobile-3to4.png");
            width: 80px;
            height: 72px;
            bottom: -66px;
            right: 45%;
            @media (min-width: 576px) {
              left: 34%;
              bottom: -66px;
            }
            @media (min-width: 768px) {
              background: url("../assets/images/lines/line-desktop-3to4.png");
              width: 60px;
              height: 48px;
              left: unset;
              right: -54px;
              top: 60%;
            }
          }
        }

        &:nth-child(4) {
          @media (min-width: 576px) {
            left: pxToRem(65);
          }
          @media (min-width: 768px) {
            border-radius: 0px 10px 10px;
            left: unset;
          }
        }
      }
    }
  }

  .connector {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;

    z-index: 1;
  }
</style>
